import React from 'react';
export function Footer() {
  return <footer className="bg-earth-900 border-t border-white/5 py-12 relative" data-id="element-54" data-mp="32wd2cf6gdjt0">
      <div className="absolute inset-0 bg-grain opacity-20 pointer-events-none mix-blend-overlay" data-id="element-55" data-mp="3ggap9r3mg53c"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-56" data-mp="32p5mig4yiwos">
        <p className="text-cream-50/40 text-sm" data-id="element-57" data-mp="36ooajks2rnvu">
          Copyright © 2025 Mark Vermeulen Coaching | Privacybeleid
        </p>
      </div>
    </footer>;
}